import classNames from 'classnames';
import React, { ComponentProps } from 'react';
import { MdSwapVerticalCircle } from 'react-icons/md';
import styles from './ChangedCostsIndicator.module.scss';

const ChangedCostsIndicator = ({ className, ...props }: ComponentProps<'svg'>) => {
  return <MdSwapVerticalCircle size={12} color="#F29423" className={classNames(styles.indicator, className)} {...props} />;
};

export default ChangedCostsIndicator;
